import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as userActions from 'store/user/actions';
import { shouldSaveCrossDevice } from 'store/user/selectors';
import { getColors } from 'store/settings/selectors';
import * as popupActions from 'store/popup/actions';
import Icon from 'components/common/Icon';
import { localize } from 'core/localization';
import { POPUP_ID_CONTINUE_LATER } from 'constants/popups';
import Popover, { ArrowContainer } from 'react-tiny-popover';
import ContinueLater from '../popups/continueLater';

import {
  MenuContainer,
  ExpandableWrapper,
  AvatarLetterContainer,
  AvatarLetterElement,
  IconContainer,
  ActionListContainer,
  ListItem,
  ItemText
} from './UserMenu.styled';
import { getAvatarLetter } from '../../store/user/selectors';

const constants = {
  defaultAvatarLetter: 'A'
};

export class UserMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false
    };
  }

  toggle = () => {
    this.setState({
      isExpanded: !this.state.isExpanded
    });
  };

  onLogout = () => {
    this.props.actions.logout();
    this.toggle();
  };

  onContinueLater = () => {
    this.props.actions.popupActions.openPopup({
      popupId: POPUP_ID_CONTINUE_LATER,
      popupAriaLabelKey: '[continue later aria label]',
      component: ContinueLater
    });
    this.toggle();
  };

  render() {
    const { ariaHidden, avatarLetter, colors, saveCrossDevice } = this.props;
    const { isExpanded } = this.state;
    return (
      <MenuContainer aria-hidden={ariaHidden}>
        <Popover
          tabIndex="1"
          isOpen={isExpanded}
          position={['bottom']}
          padding={10}
          align="end"
          transitionDuration={0.2}
          containerStyle={{ zIndex: 10 }}
          onClickOutside={this.toggle}
          content={({ position, targetRect, popoverRect }) => (
            <ArrowContainer
              position={position}
              targetRect={targetRect}
              popoverRect={popoverRect}
              arrowColor={colors.contentBodyColor}
              arrowSize={4}
              style={{ padding: '4px 8px 8px' }}
            >
              <ActionListContainer>
                {saveCrossDevice && (
                  <ListItem onClick={this.onContinueLater}>
                    <ItemText appearance="span" size={13}>
                      {localize('[continue later with link]')}
                    </ItemText>
                  </ListItem>
                )}
                <ListItem onClick={this.onLogout}>
                  <IconContainer>
                    <Icon name="logout" size={10} color="textColor" />
                  </IconContainer>
                  <ItemText appearance="span" size={13}>
                    {localize('[logout]')}
                  </ItemText>
                </ListItem>
              </ActionListContainer>
            </ArrowContainer>
          )}
        >
          <ExpandableWrapper ariaHidden={false} onClick={this.toggle} tabIndex="0">
            <AvatarLetterContainer>
              <AvatarLetterElement>
                {avatarLetter || constants.defaultAvatarLetter}
              </AvatarLetterElement>
            </AvatarLetterContainer>
            <IconContainer>
              <Icon name={isExpanded ? 'chevron-up' : 'chevron-down'} size={5} color="textColor" />
            </IconContainer>
          </ExpandableWrapper>
        </Popover>
      </MenuContainer>
    );
  }
}

UserMenu.propTypes = {
  ariaHidden: PropTypes.bool.isRequired,
  actions: PropTypes.object.isRequired,
  saveCrossDevice: PropTypes.bool.isRequired,
  avatarLetter: PropTypes.string,
  colors: PropTypes.object
};

function mapStateToProps(state) {
  return {
    avatarLetter: getAvatarLetter(state),
    colors: getColors(state),
    saveCrossDevice: shouldSaveCrossDevice(state)
  };
}

function mapDispatchToProps(dispatch) {
  let data = { actions: bindActionCreators(userActions, dispatch) };
  data.actions.popupActions = bindActionCreators(popupActions, dispatch);

  return data;
}

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu);
